import { VT2_TABLE_CONFIG } from 'vio-tables-v2';

export const BASE_VIO_TABLE_V2_CONFIG: VT2_TABLE_CONFIG = {
  isSortable: true,
  exportToExcel: true,
  showFormulaButton: false,
  showSummationButton: false,
  showHeaderGroupButton: false,
};
